import React from 'react';
// import diversionIcon from "../../../../../../../assets/diversion.svg";
import diversionIcon from "../../../../../../../assets/diversion_white_icon.svg";
import "./RecommedDiversion.css";

const RecommedDiversion = () => {
    return (
                <div className="recomment-diversion-container">
                        <div className='status-card-container'>
                            <p className='title'>Recommend Diversion</p>
                            <div className='icon-image'>
                                <img src={diversionIcon} />
                            </div>
                        </div>
                </div>
    );
}

export default RecommedDiversion;
